import React, { Component } from 'react';
import DialogBox from '../../container/MUI/DialogBox';
import InputText from './Form';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';

const PASSWORD = "UnMDPSuperDifficile";

class DeactivateCategoryDialog extends Component {
    state = {
        MDP: "",
        errors: { MDP: "" }
    };

    handleChange = (e) => {
        this.setState({ MDP: e.target.value, errors: { MDP: "" } });
    };

    handleSubmit = () => {
        if (this.state.MDP === PASSWORD) {
            this.props.onConfirm();
            this.setState({ MDP: "", errors: { MDP: "" } });
            this.props.close();
        } else {
            this.setState({
                errors: { MDP: "Mot de Passe Incorrect" }
            });
        }
    };

    handleClose = () => {
        this.setState({ MDP: "", errors: { MDP: "" } });
        this.props.close();
    };

    render() {
        return (
            <DialogBox
                disableBackdropClick
                open={this.props.open}
                close={this.handleClose}
                title="Désactiver la catégorie"
            >
                <Box>
                    <Box p={1}>
                        {this.props.categoryName}
                    </Box>
                    <Alert severity="warning">
                        <AlertTitle>Attention</AlertTitle>
                        La catégorie ne sera plus proposée dans le choix des catégories lors de la création de dépenses. Vous pourrez la réactiver à tout moment.
                    </Alert>
                    <Box p={1}>
                        <InputText
                            type="password"
                            name="MDP"
                            value={this.state.MDP}
                            label="Mot de Passe"
                            placeholder="Mot de Passe"
                            required
                            error={this.state.errors.MDP}
                            onChange={this.handleChange}
                        />
                    </Box>
                </Box>
                <Box>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary" disabled={this.props.disabledSubmit}>
                        Désactiver
                    </Button>
                    <Button onClick={this.handleClose}>
                        Annuler
                    </Button>
                </Box>
            </DialogBox>
        );
    }
}

export default DeactivateCategoryDialog;
